import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';
import styles from './index.module.less';
import cn from 'classnames';

type IProps = Omit<IconProps, 'shape'> & {
    type?: 'primary' | 'reverse' | false;
};

export const IconPoints: FC<IProps> = props => {
    const {
        type = 'primary',
        className,
        ...rest
    } = props;

    return (
        <SVG
            {...rest}
            className={cn(className, styles.points, type !== false ? styles[type] : '')}
            path="M256 320h169.941333c54.186667 0 98.133333 44.373333 98.133334 99.114667 0 54.784-43.946667 99.157333-98.133334 99.157333-36.224 0-67.84-19.84-84.821333-49.365333L256 320z m362.325333 0H768L511.701333 768l-74.453333-131.413333 181.077333-316.586667z"
        />
    )
};
